import { useEffect, useRef } from 'react'

export const useObserver = ({
  options = {
    root: null,
  },
  observerCallback,
  dep = [],
}: {
  options?: IntersectionObserverInit
  observerCallback: (entries: IntersectionObserverEntry[]) => void
  dep?: any[] // 重新建立 observer 的依據，會影響 callback 的執行結果
}) => {
  const observer = useRef<IntersectionObserver>()
  useEffect(() => {
    observer.current = new IntersectionObserver(observerCallback, options)

    return () => {
      if (observer?.current) {
        observer.current.disconnect()
      }
    }
  }, [...dep])
  return {
    observerRef: observer,
  }
}

export const useObserve = ({ observer, targetRef }: { observer?: IntersectionObserver; targetRef: any }) => {
  useEffect(() => {
    if (observer && targetRef) {
      observer.observe(targetRef)
    }
    return () => {
      if (observer && targetRef) {
        observer.unobserve(targetRef)
      }
    }
  }, [observer, targetRef])

  return [observer]
}
